import React, { useEffect, useState } from "react";
import actions from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import { notifyError } from "../../components/ToastContext";
import ChangePassword from "../../components/Models/ChangePassword";
import TwoFactorService from "../../services/twoFactorService";

const SignIn = () => {
  const navigate = useNavigate();

  const [data, setData] = useState({
    Username: "",
    Password: "",
    LatLong: "string",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [tempToken, setTempToken] = useState("");
  const [twoFactorCode, setTwoFactorCode] = useState("");
  const [isVerifying2FA, setIsVerifying2FA] = useState(false);
  const [twoFactorError, setTwoFactorError] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    /* if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
          },
          (error) => {
            if (error.code === error.PERMISSION_DENIED) {
              alert("Please Allow Location to Access this Application");
            }
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
      // Fetch IP Address
      // fetch('https://ipinfo.io/json')
      //   .then(response => response.json())
      //   .then(data => setIp(data.ip))
      //   .catch(error => console.error('Error fetching IP:', error));
      */
  }, []);
  /*
    useEffect(() => {
      if (latitude !== null && longitude !== null) {
        fetchCoordinates(latitude, longitude);
      }
    }, [latitude, longitude]);
  */
  function fetchCoordinates(latitude, longitude) {
    const locationURL = `https://geocode.maps.co/reverse?lat=${latitude}&lon=${longitude}`;
    fetch(locationURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        //console.log(data)
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  const completeLogin = async (userData) => {
    localStorage.setItem("loginUserDetails", JSON.stringify(userData));
    if (userData?.Role === "Manager") {
      let roleByUser = await actions.getRoleByUser(userData?.uid);
      let roleData = roleByUser?.data?.Result;
      let roleKeyArray = Array.isArray(roleData)
        ? roleData.map((item) => item.Role_key)
        : [];
      localStorage.setItem("ManagerRole", JSON.stringify(roleKeyArray));
    } else {
      localStorage.removeItem("ManagerRole");
    }
    localStorage.setItem("isAuthenticated", "true");
    window.location = "/home";
  };

  const login = async (e) => {
    e.preventDefault();
    if (data.Password.trim() !== "" && data.Username.trim() !== "") {
      setIsLoading(true);
      try {
        const res = await actions.loginAction(data);
        if (res?.status === 200) {
          if (!res?.data?.Status) {
            notifyError(res?.data?.Result);
          } else if (res?.data?.Requires2FA) {
            setTempToken(res.data.TempToken);
            setTwoFactorCode("");
            setTwoFactorError("");
            setShow2FAModal(true);
          } else {
            await completeLogin(res?.data);
          }
        } else {
          notifyError(res?.data?.Result);
        }
      } catch (error) {
        console.log("res", error);
        notifyError(error.message);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleVerify2FA = async (e) => {
    if (e) e.preventDefault();
    if (!twoFactorCode || twoFactorCode.trim().length < 6) {
      setTwoFactorError("Please enter your 6-digit code or recovery code.");
      return;
    }
    setIsVerifying2FA(true);
    setTwoFactorError("");
    try {
      const res = await TwoFactorService.verifyLogin(tempToken, twoFactorCode.trim());
      if (res?.data?.Status && res?.data?.Token) {
        setShow2FAModal(false);
        await completeLogin(res.data);
      } else {
        setTwoFactorError(res?.data?.Result || res?.data?.Message || "Invalid code. Please try again.");
      }
    } catch {
      setTwoFactorError("Failed to verify code. Please check your connection.");
    } finally {
      setIsVerifying2FA(false);
    }
  };

  return (
    <div className="bg-gradient-primary" style={{ minHeight: "100vh" }}>
      <div className="container">
        {/* Outer Row */}
        <ChangePassword
          handleModalClose={handleCloseModal}
          showModal={showModal}
        />
        <div className="row justify-content-center h-100">
          <div className="col-xl-10 col-lg-12 col-md-9">
            <div
              className="card o-hidden border-0 shadow-lg my-5"
              style={{ height: "400px" }}
            >
              <div className="card-body p-0 h-100">
                {/* Nested Row within Card Body */}
                <div className="row h-100">
                  <div className="col-lg-6 d-none d-lg-block bg-login-image" />
                  <div className="col-lg-6">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>
                      </div>
                      <form className="user">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control form-control-user"
                            name="Username"
                            id="exampleInputEmail"
                            aria-describedby="emailHelp"
                            placeholder="Enter Username..."
                            value={data?.Username}
                            onChange={(e) =>
                              setData({ ...data, Username: e.target.value })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <input
                            type="password"
                            className="form-control form-control-user"
                            id="exampleInputPassword"
                            placeholder="Password"
                            name="Password"
                            value={data?.Password}
                            onChange={(e) =>
                              setData({ ...data, Password: e.target.value })
                            }
                          />
                        </div>
                        {/* <div className="form-group">
                          <div className="custom-control custom-checkbox small">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="customCheck"
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="customCheck"
                            >
                              Remember Me
                            </label>
                          </div>
                        </div> */}
                        <button
                          type="submit"
                          className="btn btn-primary  w-100"
                          onClick={login}
                          disabled={isLoading}
                        >
                          {isLoading ? "Loading..." : "Submit"}
                        </button>
                        <span
                          style={{
                            color: "blue",
                            fontSize: "14px",
                            cursor: "pointer",
                          }}
                          data-toggle="modal"
                          data-target="#changePassword"
                          onClick={handleShowModal}
                        >
                          change password ?
                        </span>
                        {/* <hr /> */}
                        {/* <a
                          href="index.html"
                          className="btn btn-google btn-user btn-block"
                        >
                          <i className="fab fa-google fa-fw" /> Login with Google
                        </a>
                        <a
                          href="index.html"
                          className="btn btn-facebook btn-user btn-block"
                        >
                          <i className="fab fa-facebook-f fa-fw" /> Login with
                          Facebook
                        </a> */}
                      </form>
                      {/* <hr /> */}
                      <div className="text-center">
                        {/* <a className="small" href="forgot-password.html">
                          Forgot Password?
                        </a> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* SubAdmin Two-Factor Authentication Login Verification Modal */}
      {show2FAModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.65)", zIndex: 1060 }}
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "390px" }}>
            <div className="modal-content shadow-lg" style={{ borderRadius: "8px", border: "1px solid #4e73df" }}>
              <div className="modal-header bg-dark text-white p-3 d-flex justify-content-between align-items-center">
                <h6 className="modal-title m-0 text-white font-weight-bold">
                  <i className="fas fa-shield-alt mr-2 text-warning" /> Two-Factor Verification
                </h6>
                <button
                  type="button"
                  className="close text-white"
                  style={{ background: "transparent", border: "none", fontSize: "20px", cursor: "pointer" }}
                  onClick={() => setShow2FAModal(false)}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body p-4 text-center">
                <p style={{ fontSize: "13px", color: "#5a5c69", marginBottom: "16px" }}>
                  Enter the 6-digit code from your <strong>Google Authenticator</strong> app:
                </p>
                {twoFactorError && (
                  <div className="alert alert-danger p-2 mb-3" style={{ fontSize: "12px" }}>
                    {twoFactorError}
                  </div>
                )}
                <form onSubmit={handleVerify2FA}>
                  <input
                    type="text"
                    maxLength="12"
                    autoFocus
                    placeholder="000000"
                    className="form-control text-center mb-3"
                    style={{ fontSize: "22px", letterSpacing: "4px", fontWeight: "bold" }}
                    value={twoFactorCode}
                    onChange={(e) => setTwoFactorCode(e.target.value)}
                  />
                  <div className="d-flex justify-content-between mt-3">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => setShow2FAModal(false)}
                      disabled={isVerifying2FA}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary btn-sm px-3"
                      disabled={isVerifying2FA || !twoFactorCode.trim()}
                    >
                      {isVerifying2FA ? "Verifying..." : "Verify & Log In"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SignIn;
